export enum TypeOfIcon {
  IconAccepted = 'check_box',
  IconPartlyAccepted = 'indeterminate_check_box',
  IconShortDate = 'calendar_today',
  IconOverloaded = 'control_point',
}
